var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3999 11.9999C3.3999 7.25025 7.25025 3.3999 11.9999 3.3999C16.7496 3.3999 20.5999 7.25025 20.5999 11.9999C20.5999 16.7496 16.7496 20.5999 11.9999 20.5999C7.25025 20.5999 3.3999 16.7496 3.3999 11.9999ZM11.9999 4.5999C7.913 4.5999 4.5999 7.913 4.5999 11.9999C4.5999 16.0868 7.913 19.3999 11.9999 19.3999C16.0868 19.3999 19.3999 16.0868 19.3999 11.9999C19.3999 7.913 16.0868 4.5999 11.9999 4.5999ZM11.9999 7.3999C12.3313 7.3999 12.5999 7.66853 12.5999 7.9999V12.5713C12.5999 12.9027 12.3313 13.1713 11.9999 13.1713C11.6685 13.1713 11.3999 12.9027 11.3999 12.5713V7.9999C11.3999 7.66853 11.6685 7.3999 11.9999 7.3999ZM11.9999 14.8285C12.3313 14.8285 12.5999 15.0971 12.5999 15.4285V15.4399C12.5999 15.7713 12.3313 16.0399 11.9999 16.0399C11.6685 16.0399 11.3999 15.7713 11.3999 15.4399V15.4285C11.3999 15.0971 11.6685 14.8285 11.9999 14.8285Z",
    fill: "#ffbe42"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f656d6cde80fa935d431c3243caf4a2f.svg";
export { ForwardRef as ReactComponent };